import React from "react";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import RemoveCircleOutlineIcon from '@material-ui/icons/RemoveCircleOutline';

/**
 * props: element, label, user, globals
 */
class Members extends React.Component {
    constructor(props) {
        super(props);

        this.addMember = this.addMember.bind(this);
        this.removeMember = this.removeMember.bind(this);
    }

    render() {
        const element = this.props.element;

        if (!element.members) {
            return null;
        }
        // console.log("Members:", this.props.user, element.members);

        let iAmMember = element.members.filter(m => m.id === this.props.user.id).length > 0;

        return (
            <div>
                {this.props.label && this.props.label + ": "}
                {element.members.length > 0 ? element.members.map(m => m.name).join(', ') : "None"}
                {iAmMember ?
                    <Tooltip title="Remove me">
                        <IconButton aria-label="remove me" onClick={this.removeMember}>
                            <RemoveCircleOutlineIcon/>
                        </IconButton>
                    </Tooltip> :
                    <Tooltip title="Add me">
                        <IconButton aria-label="add me" onClick={this.addMember}>
                            <AddCircleOutlineIcon/>
                        </IconButton>
                    </Tooltip>
                }
            </div>
        );
    }

    addMember() {
        console.log("addMember");
        this.props.globals.addLink(this.props.element, "members", this.props.user)
            .then(res => res.json())
            .then(
                (result) => {
                    console.log("Result", result);
                    this.props.elementUpdated(result);
                },
                (error) => {
                    console.error(error);
                }
            )
    }

    removeMember() {
        console.log("removeMember");
        this.props.globals.removeLink(this.props.element, "members", this.props.user)
            .then(res => res.json())
            .then(
                (result) => {
                    console.log("Result", result);
                    this.props.elementUpdated(result);
                },
                (error) => {
                    console.error(error);
                }
            )
    }
}

export default Members;
